import { render, staticRenderFns } from "./NoPlanSubscription.vue?vue&type=template&id=65831f3a&"
import script from "./NoPlanSubscription.vue?vue&type=script&lang=js&"
export * from "./NoPlanSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports